import ItemPartViewState from '../../store/schema/ItemPartViewState';
import { getParentItemPart } from '../../utils/rollUp/rollUpUtils';
import { ObservableMap } from 'mobx';
import { ConversationReadingPaneNode } from 'owa-mail-store';
import { action } from 'satcheljs/lib/legacy';

export default action('tryAddCalendarNodesInRollUp')(function tryAddCalendarNodesInRollUp(
    itemPartsMap: ObservableMap<string, ItemPartViewState>,
    conversationNodes: ObservableMap<string, ConversationReadingPaneNode>,
    conversationNodeIds: string[],
    shouldCleanUpChildrenNodes: boolean,
    addedNodes?: string[]
) {
    // If it's update scenario, we need to clean up the children nodes and build it again.
    // If not, we could not confirm the children nodes sequence in update scenario.
    if (shouldCleanUpChildrenNodes) {
        itemPartsMap.forEach(itemPartViewState => {
            itemPartViewState.calendarRollUpViewState.calendarReponseNodeIds = [];
        });
    }

    conversationNodeIds.forEach(nodeId => {
        const itemPartViewState = itemPartsMap.get(nodeId);
        if (!itemPartViewState || !itemPartViewState.calendarRollUpViewState.isCalendarResponse) {
            return;
        }

        // Reset isInRollUp to false in case that the parent node is deleted.
        itemPartViewState.isInRollUp = false;

        // Try to find the parent node
        const parentItemPart = getParentItemPart(nodeId, itemPartsMap, conversationNodes);
        if (parentItemPart) {
            itemPartViewState.isInRollUp = true;
            parentItemPart.calendarRollUpViewState.calendarReponseNodeIds.push(nodeId);

            // If this item part is expanded/unread the calendar roll up should be expanded if one of the following is true:
            // - This is the first load
            // - The item part is included in the added nodes
            // If the roll up is already expanded, we should NOT collapse it when update conversation
            if (
                itemPartViewState.isExpanded &&
                !parentItemPart.calendarRollUpViewState.isExpanded
            ) {
                parentItemPart.calendarRollUpViewState.isExpanded =
                    !shouldCleanUpChildrenNodes || (addedNodes && addedNodes.includes(nodeId));
            }
        }
    });
});
